module.exports = __webpack_public_path__ + "static/media/fionagu.684dd5d3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/fionagu.webp
// module id = 337
// module chunks = 0